const keys = {
  INVALID_ZIPCODE: 'account.components.address.errors.invalid_zipcode',
};

// Validation Error messages
export const INVALID_IL_ZIPCODE = 'Must be either 5 or 7 characters';

// Translation Keys
export const LABEL_ADDRESS_1 = 'common.forms.labels.address_1';

export const INVALID_ZIPCODE =
  global.translations.messages[keys.INVALID_ZIPCODE];

// Modal components messages
export const MODAL_FOOTER_CONFIRM_BUTTON = 'common.modals.confirm';
export const MODAL_FOOTER_CANCEL_BUTTON = 'common.modals.cancel';



// WEBPACK FOOTER //
// ./app/javascript/common/messages.js